import { Pipe, PipeTransform } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { CodeListValue } from '@bo-client/shared/models/codeListValue';
import { MetaService } from '@bo-client/core/api/meta-service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { filter } from 'rxjs/operators';

@Pipe({
  name: 'codeListValues$'
})
export class CodeListValuePipe implements PipeTransform {
  constructor(private dataShareService: DataShareService, private metaService: MetaService) {}
  transform(codeListName: string): Observable<CodeListValue[]> {
    return this.dataShareService.currentTenant$.pipe(
      switchMap((tenant) =>
        this.metaService.codeListValues$(codeListName, tenant.id).pipe(filter((x) => x.length > 0))
      )
    );
  }
}
